var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFormularz(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 143 184.41",
    height: 57,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .d {\r\n        fill: none;\r\n        stroke-linecap: round;\r\n        stroke-linejoin: round;\r\n        stroke-width: 9px;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a",
    "data-name": "Layer 1"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    stroke: "#fff",
    d: "M25.5,17.09h-3c-9.94,0-18,8.06-18,18v126.82c0,9.94,8.06,18,18,18H120.5c9.94,0,18-8.06,18-18V35.09c0-9.94-8.06-18-18-18h-3"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "d",
    stroke: "#fff",
    points: "41 35.09 22.5 35.09 22.5 161.91 87.5 161.91 87.5 128.91 120.5 128.91 120.5 35.09 102 35.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    stroke: "#fff",
    d: "M84.5,17.5c0-7.18-5.82-13-13-13s-13,5.82-13,13h-17.5v31h61V17.5h-17.5Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    stroke: "#fff",
    x1: 87.5,
    y1: 161.5,
    x2: 120.5,
    y2: 128.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    stroke: "#fff",
    x1: 41,
    y1: 69,
    x2: 102,
    y2: 69
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    stroke: "#fff",
    x1: 41,
    y1: 91,
    x2: 102,
    y2: 91
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    stroke: "#fff",
    x1: 41,
    y1: 113,
    x2: 70,
    y2: 113
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormularz);
export default __webpack_public_path__ + "static/media/formularz.9aba60a82dbe1b6f52c70972d2a76f06.svg";
export { ForwardRef as ReactComponent };